import React, { useCallback, useContext, useEffect, useState } from 'react';
import { DataLayerEventContext } from '../contexts/dataLayerEventContext';
import { ScreensContext } from '../contexts/screensContext';
import { SohoVibeContext } from '../common/soho-vibe-flow-wrapper/context';
import ErrorScreen from '../components/lm-d-s/errorScreen';
import { getImageFromS3 } from '../imageService';
import ProductScreen from '../components/25ua-prl-sh-s-ssl-new/product-screen';
import NewReviewFlowScreen from '../common/new-review-flow-screen';
import AuthorityScreen from '../common/authority-screen';
import AllBrandsScreen from '../common/all-brands-screen';
import BrandLineScreen from '../common/brand-line-screen';

const partners = {
  cig: 'https://cig-poshta.in.ua/shop/parliament/?utm_source=SP',
  rozetka: 'https://rozetka.com.ua/ua/sigareti/c4638591/producer=parliament/'
};

const PRLShSSSLNew = () => {
  const { isReviewRequested } = useContext(SohoVibeContext);
  const initialScreenNumber = isReviewRequested ? 2 : 1;
  const [instanceId] = useState(() => Math.random().toString(36).substring(7));
  const [screenNumber, setScreenNumber] = useState(initialScreenNumber);
  const [historyState, setHistoryState] = useState({});
  const [endSessionType, setEndSessionType] = useState('SESSION_END');
  const [isDisplayedAll, setIsDisplayedAll] = useState(false);
  const [brandLine, setBrandLine] = useState('parliament');

  // Штучна навігація: системна кнопка "Назад" гортає екрани сторінки і не
  // змінює URL. Кожен запис історії підписаний instanceId, а App.js пропускає
  // popstate зі state.screenNumber повз свій глобальний перехоплювач.
  useEffect(() => {
    const handlePopState = (event) => {
      const state = event.state;
      if (
        state &&
        state.instanceId === instanceId &&
        typeof state.screenNumber === 'number'
      ) {
        setScreenNumber(state.screenNumber);
        setHistoryState(state);
        if (state.brandLine) setBrandLine(state.brandLine);
      }
    };

    window.addEventListener('popstate', handlePopState);

    const initialState = {
      screenNumber: initialScreenNumber,
      brandLine: 'parliament',
      instanceId
    };
    window.history.replaceState(initialState, '', window.location.href);
    setHistoryState(initialState);

    return () => window.removeEventListener('popstate', handlePopState);
  }, [instanceId, initialScreenNumber]);

  const handleSetScreenNumber = useCallback(
    (number, isBack = false, extraState = {}) => {
      setScreenNumber(number);
      const newState = {
        ...window.history.state,
        screenNumber: number,
        instanceId,
        ...extraState
      };
      setHistoryState(newState);
      if (extraState.brandLine) setBrandLine(extraState.brandLine);
      if (isBack) {
        window.history.replaceState(newState, '', window.location.href);
      } else {
        window.history.pushState(newState, '', window.location.href);
      }
    },
    [instanceId]
  );

  const handleUpdateHistoryState = useCallback(
    (extraState) => {
      const newState = { ...window.history.state, instanceId, ...extraState };
      setHistoryState(newState);
      window.history.pushState(newState, '', window.location.href);
    },
    [instanceId]
  );
  const { init, sendEvent } = useContext(DataLayerEventContext);

  useEffect(() => {
    init('PRL-Sh-S-SSL-new');
    sendEvent('age_verification_without');
  }, [init]);

  const getScreen = (number, cb) => {
    switch (number) {
      case 1: {
        return (
          <ProductScreen
            backgroundImage={`url("${getImageFromS3(
              'images/25ua-prl-sh-s-ssl/bg.png'
            )}")`}
            handleToReview={() => cb(2)}
            handleToAuthority={() => cb(3)}
            handleToBrandLine={() => cb(4)}
          />
        );
      }
      case 2: {
        return <NewReviewFlowScreen setScreenNumber={(n) => cb(n, n === 1)} />;
      }
      case 3: {
        return (
          <AuthorityScreen
            partners={partners}
            setScreenNumber={cb}
            handleBackToMenu={() => cb(1, true)}
            setReviewScreenNumber={() => cb(2)}
          />
        );
      }
      case 4: {
        return (
          <BrandLineScreen
            brandId={brandLine}
            setScreenNumber={cb}
            backButtonClick={() => cb(5, true)}
            nextButtonClick={() => cb(1)}
            withoutHeader
            historyState={historyState}
            updateHistoryState={handleUpdateHistoryState}
          />
        );
      }
      case 5: {
        return (
          <AllBrandsScreen
            setScreenNumber={cb}
            setBrandLine={(brand) => cb(4, false, { brandLine: brand })}
            handleBackButton={() => cb(1, true)}
            withoutHeader
            historyState={historyState}
            updateHistoryState={handleUpdateHistoryState}
          />
        );
      }
      default: {
        return <ErrorScreen setScreenNumber={cb} />;
      }
    }
  };

  return (
    <ScreensContext.Provider
      value={{
        endSessionType,
        setEndSessionType,
        isDisplayedAll,
        setIsDisplayedAll
      }}
    >
      {getScreen(screenNumber, handleSetScreenNumber)}
    </ScreensContext.Provider>
  );
};

export default PRLShSSSLNew;
